import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * OAuth Callback Page
 * 
 * This page is opened in a popup window after OAuth authorization.
 * It sends a message to the opener window and then closes itself.
 */
function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success');
  const provider = searchParams.get('provider');
  const error = searchParams.get('error');

  useEffect(() => {
    // Check if we're in a popup window
    if (window.opener) {
      // Send message to opener window
      const message = {
        type: 'oauth-callback',
        success: success === 'true',
        provider: provider || null,
        error: error || null
      };

      console.log('📤 Sending OAuth callback message to opener:', message);
      window.opener.postMessage(message, window.location.origin);

      // Close the popup after a short delay
      setTimeout(() => {
        window.close();
      }, 100);
    } else {
      // Not in a popup, redirect to home or show message
      console.warn('⚠️ OAuth callback not in popup window');
      if (success === 'true') {
        // Redirect to home or settings
        window.location.href = '/';
      }
    }
  }, [success, provider, error]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        {success === 'true' ? (
          <>
            <h2 style={{ color: '#4CAF50' }}>✅ Connection Successful!</h2>
            <p>Closing window...</p>
          </>
        ) : error ? (
          <>
            <h2 style={{ color: '#f44336' }}>❌ Connection Failed</h2>
            <p>{error}</p>
            <p>Closing window...</p>
          </>
        ) : (
          <>
            <h2>Processing...</h2>
            <p>Please wait...</p>
          </>
        )}
      </div>
    </div>
  );
}

export default OAuthCallback;
